import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OAuthService } from 'angular-oauth2-oidc'
import { from, Observable, throwError } from 'rxjs'
import { catchError, finalize, switchMap } from 'rxjs/operators'
import { httpStatus } from 'src/domain/enums/http-status.enum'

@Injectable({
	providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
	private isRefreshing = false
	private refreshQueue: Array<() => void> = []

	constructor(private oauthService: OAuthService) {}
	get HttpStatusCode() {
		return httpStatus
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.oauthService.hasValidAccessToken()) {
			if (!req.headers.get('Authorization')) {
				req = req.clone({
					setHeaders: {
						Authorization: 'Bearer ' + this.oauthService.getAccessToken(),
					},
				})
			}
		}

		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status === this.HttpStatusCode.Unauthorized) {
					return this.handle401Error(req, next)
				}
				return throwError(() => error)
			}),
		)
	}
	// skipcq: JS-0323
	private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!this.isRefreshing) {
			this.isRefreshing = true
			return from(this.oauthService.silentRefresh()).pipe(
				switchMap(() => {
					this.isRefreshing = false
					// Retry all queued requests
					this.refreshQueue.forEach((cb) => cb())
					this.refreshQueue = []
					// Clone request with new token
					const token = this.oauthService.getAccessToken()
					const authReq = req.clone({
						setHeaders: { Authorization: `Bearer ${token}` },
					})
					return next.handle(authReq)
				}),
				catchError((err) => {
					this.isRefreshing = false
					this.refreshQueue = []
					return throwError(() => err)
				}),
				finalize(() => {
					this.isRefreshing = false
				}),
			)
		} else {
			// If already refreshing, queue the request
			// skipcq: JS-0323
			return new Observable<HttpEvent<any>>((observer) => {
				this.refreshQueue.push(() => {
					const token = this.oauthService.getAccessToken()
					const authReq = req.clone({
						setHeaders: { Authorization: `Bearer ${token}` },
					})
					next.handle(authReq).subscribe({
						next: (event) => observer.next(event),
						error: (err) => observer.error(err),
						complete: () => observer.complete(),
					})
				})
			})
		}
	}
}
